import { BreakpointsMinQuery } from '@ab-core/breakpoints';
import { RADIUS } from '@ab-core/radius';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const CardInfo = styled.div`
    display: flex;
    flex-direction: column;
    @media ${BreakpointsMinQuery.sm} {
        flex-direction: row;
        gap: ${SPACING.MEDIUM_3};
    }
`;

export const Picture = styled.div`
    overflow: hidden;
    border-radius: ${RADIUS.CIRCLE};
    max-width: 148px;
    height: 148px;
    margin-left: ${SPACING.NONE};
    @media ${BreakpointsMinQuery.sm} {
        min-width: 220px;
        height: 220px;
    }

    .ab-image {
        object-position: right center;
    }
`;
